import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { Input } from '../../components/Input';
import { Spinner } from '../../components/Spinner';
import { APP_ROUTES } from '../../constants';
import { authService } from '../../services/auth';
import { appDataActions } from '../../store/appData/appDataActions';
import { CUENTAS_DEMO, EN_DEMO, MOSTRAR_LOGIN_RAPIDO, MSG_DEMO } from '../../utils/demo';

// Panel de login rapido con las cuentas de prueba: solo donde config.js las trae (la demo).

export const FormLogin = ({ noDelayEntranceRef, returnPath }) => {
    const initialInputsValues = {
        email: "",
        password: "",
    }

    const [inputsForm, setInputsForm] = useState(initialInputsValues)
    const [formError, setFormError] = useState({});
    const [validated, setValidate] = useState(false);

    const [fetchError, setFetchError] = useState();
    const [isFetching, setIsFetching] = useState();

    const isMountedSignalRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClickCrearCuenta = () => {
        noDelayEntranceRef.current = true;
        navigate(APP_ROUTES.CREAR_CUENTA, { state: { returnPath } });
    }

    const ingresar = async (credenciales) => {
        setFetchError("")
        setIsFetching(true)

        try {
            await authService.loginAccount(credenciales)
            navigate(returnPath ?? APP_ROUTES.HOME)
            dispatch(appDataActions.hideAlertNotification())
        }
        catch (err) {
            setFetchError("El email o contraseña son incorrectos")
        }
        finally {
            setIsFetching(false)
        }
    }

    const handleIngresar = async (evento) => {
        if (evento) evento.preventDefault();
        setValidate(true)

        if (!(Object.keys(formError).length > 0)) await ingresar(inputsForm)
    }

    const handleLoginRapido = (evento, { email, password }) => {
        evento.preventDefault();
        ingresar({ email, password })
    }

    const handleKeyDown = (evento) => {
        if (evento.target.tagName == "INPUT" && evento.key === "Enter") {
            if (evento) evento.preventDefault();
            handleIngresar();
        }
    }

    useEffect(() => {
        setValidate(false);
    }, [inputsForm])

    useEffect(() => {
        const abortController = new AbortController();
        isMountedSignalRef.current = abortController.signal;
        return () => abortController.abort();
    }, [])

    return (
        <div className="formLogin-container initialOpacity leftEntranceOpacity" style={noDelayEntranceRef.current ? { animationDelay: "150ms" } : { animationDelay: "750ms" }}>
            <h1 className="formLogin__title">Iniciar sesion</h1>

            {fetchError &&
                <div className="alert alert-danger" role="alert">{fetchError}</div>
            }

            <form className="formLogin__form" autoComplete="off" onKeyDown={handleKeyDown}>
                <Input
                    name="email"
                    required
                    placeholder="Email"
                    inputsForm={inputsForm}
                    setInputsForm={setInputsForm}
                    setFormError={setFormError}
                    validated={validated}
                    noShowSuccesState={true}
                    disabled={isFetching}
                />
                <Input
                    name="password"
                    required
                    inputsForm={inputsForm}
                    setInputsForm={setInputsForm}
                    setFormError={setFormError}
                    validated={validated}
                    noShowSuccesState={true}
                    placeholder="Contraseña"
                    type="password"
                    disabled={isFetching}
                />
                <Link className="btn-anchor btn-anchor-secondary btn-anchor-sm" to={APP_ROUTES.RECUPERAR}>Olvidaste tu contraseña?</Link>
                <div className="formLogin__buttons-container">
                    <button className="btn-anchor btn-anchor-primary" onClick={handleClickCrearCuenta} disabled={EN_DEMO} title={EN_DEMO ? MSG_DEMO : undefined}>Crear cuenta</button>
                    <button className="btn-primary btn-with-icon" onClick={handleIngresar} disabled={isFetching}>
                        {isFetching ?
                            <><Spinner size="20"></Spinner>Ingresando</>
                            : "Ingresar"}
                    </button>
                </div>
            </form>

            {MOSTRAR_LOGIN_RAPIDO &&
                <div className="formLogin__rapido">
                    <p className="formLogin__rapido-title">Ingresar como:</p>
                    <div className="formLogin__rapido-buttons">
                        {CUENTAS_DEMO.map(cuenta =>
                            <button key={cuenta.rol} className="btn-secondary btn-small" onClick={(evento) => handleLoginRapido(evento, cuenta)} disabled={isFetching}>{cuenta.rol}</button>
                        )}
                    </div>
                </div>
            }
        </div>
    )
}
